import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  Paper,
  Divider,
} from '@material-ui/core';

import { Assets } from 'enums';
import { branding } from '../../config/portalBranding';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  appBar: {
    marginBottom: theme.spacing(3),
  },
  content: {
    padding: theme.spacing(3),
    textAlign: 'left',
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  logo: {
    width: '100%',
    maxWidth: '400px',
  },
}));

// Japanese privacy policy — content copied VERBATIM from the
// client-approved privacy_policy_jp.md. Do not retranslate or
// paraphrase. Layout mirrors the English Privacy.tsx structure:
//   #   -> page title (h4 banner)
//   ##  -> section heading (h6)
//   ### -> sub-section heading (h6) under section 2
//   **bold** -> subtitle1 label
//   - bullet -> <ul><li>
function PrivacyJp() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.appBar}>
        <Toolbar>
          <Typography variant="h6"> プライバシーポリシー</Typography><br/>
        </Toolbar>
      </AppBar>
      <Container maxWidth="lg" className={classes.content}>
        <Paper className={classes.paper}>
          <div style={{ textAlign: 'center' }}>
            <img alt="Logo" src={branding.logo || Assets.Logo2} className={classes.logo} />
          </div>
          <Typography variant="h4" style={{ textAlign: 'center' }} gutterBottom>
            プライバシーポリシー
          </Typography><br/>

          {/* 1. はじめに */}
          <Typography variant="h6">1. はじめに</Typography><br/>
          <Typography variant="body1" style={{ color: '#001627' }}>
            本プライバシーポリシーは、DataXing Digitalおよびその関連会社（総称して「DataXing Digital (以下、データエキシング デジタル)」）が提供するNipponPollsのモニター会員（以下「モニター」）のプライバシー保護に対してどのように取り組むかを定めるとともに、プライバシーおよびデータ保護に関するモニターの権利を規定するものです。本ポリシーはNipponPollsモニターサイト上で「NipponPolls モニター プライバシーポリシー」として公開されています。
          </Typography><br/>
          <Typography variant="body1" style={{ color: '#001627' }}>
            モニターは、本モニターのメンバーであり、データエキシング デジタルによって運営されています。データエキシング デジタルは、日本の個人情報保護法（APPI）に基づき、個人情報を取り扱う事業者として機能します。
          </Typography><br/>
          <Typography variant="body1" style={{ color: '#001627' }}>
            当社のモニター、アンケート、および調査活動への参加は完全に任意です。本モニターに登録し、本規約に同意することにより、本プライバシーポリシーの内容を読み、理解したことを確認したものとみなされます。本プライバシーポリシーを注意深くお読みください。
          </Typography><br/>
          <Typography variant="body1" style={{ color: '#001627' }}>
            本プライバシーポリシーにおいて、個人情報とは、日本の個人情報保護法（APPI）に定義されるとおり、氏名、生年月日、その他の記述等により特定の個人を識別できる、生存する個人に関する情報をいいます。
          </Typography>

          {/* 2. 個人情報の取得および利用 */}
          <Typography variant="h6">2. 個人情報の取得および利用</Typography><br/>
          <Typography variant="body1" style={{ color: '#001627' }}>
            当社は、ウェブサイト（例：モニターポータル）、モバイルアプリケーション、ソーシャルメディア、アプリ、オンライン、対面、電話調査、その他の調査活動など、さまざまな方法で個人情報を取得します。今後、取得方法や活動を追加する場合がありますが、常に本プライバシーポリシーに準拠して運用します。
          </Typography><br/>
          <Typography variant="body1" style={{ color: '#001627' }}>
            当社は、個人情報の利用目的を明確に特定し、法令で認められる場合を除き、その目的の達成に必要な範囲を超えて個人情報を利用しません。
          </Typography><br/>
          <Typography variant="body1" style={{ color: '#001627' }}>
            当社は、以下に基づいて個人情報を処理します：
          </Typography><br/>
          <ul style={{ color: '#001627' }}>
            <li>お客様が同意を提供した場合；</li>
            <li>お客様との契約履行に必要な場合；</li>
            <li>法的義務を遵守するために必要な場合；</li>
            <li>重要な利益を保護するために必要な場合；</li>
            <li>調査活動に関連する正当な事業目的のために必要な場合；</li>
            <li>APPIに基づく適切な保護措置のもと、研究目的で処理される場合。</li>
          </ul>
          <Typography variant="body1" style={{ color: '#001627' }}>
            当社は、自らの身元や活動目的について虚偽の表示を行うことはありません。当社からのものと称する電子メールや連絡に懸念がある場合は、「お問い合わせ方法」に記載された方法でご連絡ください。
          </Typography><br/>

          {/* ### 当社ウェブサイトの運営 */}
          <Typography variant="h6">当社ウェブサイトの運営</Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>目的</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            当社サイトのコンテンツが、アクセスしているデバイスに応じて適切に表示されるようにするため。
          </Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            ユーザーの閲覧行動やパターンに関する統計データを分析するため。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>取得／処理されるデータ</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            IPアドレス、オペレーティングシステム情報、ブラウザの種類。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>取得元</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            これらのデータはお客様から直接取得します。
          </Typography><br/>
          <Divider /><br/>

          {/* ### モニター登録および管理 */}
          <Typography variant="h6">モニター登録および管理</Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>目的</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            モニタープロフィールの管理およびお客様との連絡（モニターに関する通知、アンケートへの選定、調査参加の依頼、インセンティブの提供、サポート提供を含む）のため。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>取得／処理されるデータ</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            氏名、メールアドレス、住所、モバイルデバイスID、人口統計情報、世帯情報。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>取得元</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            これらのデータはお客様から直接取得します。
          </Typography><br/>
          <Divider /><br/>

          {/* ### 市場調査 */}
          <Typography variant="h6">市場調査</Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>目的</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            製品やサービスに関する意見や、さまざまな状況における行動を理解するため。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>取得／処理されるデータ</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            識別情報、連絡先情報、メールアドレス、音声、画像、意見。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>取得元</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            これらのデータはお客様から直接取得します。
          </Typography><br/>
          <Divider /><br/>

          {/* ### 学術機関、公衆衛生機関、研究機関のための科学的研究 */}
          <Typography variant="h6">学術機関、公衆衛生機関、研究機関のための科学的研究</Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>目的</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            臨床研究、医療経済・アウトカム研究（HEOR）、非介入研究(NIS)、リアルワールド研究(RWR)、観察研究、疫学研究などを含みますが、これらに限定されません。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>取得／処理されるデータ</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            識別情報、連絡先情報、メールアドレス、疾患、診断、治療パターン、未充足ニーズなどの健康データ。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>取得元</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            これらのデータはお客様から直接取得するか、または他の二次データベースと組み合わせて取得します。
          </Typography><br/>
          <Divider /><br/>

          {/* ### 商業企業および慈善研究機関のための科学的研究 */}
          <Typography variant="h6">商業企業および慈善研究機関のための科学的研究</Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>目的</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            HEOR、NIS、RWR、観察研究、疫学研究などを含みますが、これらに限定されません。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>取得／処理されるデータ</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            識別情報、連絡先情報、メールアドレス、健康関連データ。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>取得元</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            これらのデータはお客様から直接取得するか、または他の二次データベースと組み合わせて取得します。
          </Typography><br/>
          <Divider /><br/>

          {/* ### 安全性監視（ファーマコビジランス／有害事象報告） */}
          <Typography variant="h6">安全性監視（ファーマコビジランス／有害事象報告）</Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>目的</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            必要に応じて、調査中に発生した有害事象を関係当局へ報告するため。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>取得／処理されるデータ</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            識別情報、連絡先情報、メールアドレス、疾患、治療、使用された製品、有害事象。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>取得元</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            これらのデータはお客様から直接取得するか、または他の二次データベースと組み合わせて取得します。
          </Typography><br/>
          <Divider /><br/>

          {/* ### 公開開示 */}
          <Typography variant="h6">公開開示</Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>目的</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            司法、規制、または政府機関からの召喚状、令状、命令、その他の法的または規制上の要件に対応するため。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>取得／処理されるデータ</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            識別情報、氏名、連絡先情報、メールアドレス、インセンティブ情報。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>取得元</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            これらのデータはお客様から直接取得するか、または他の二次データベースと組み合わせて取得します。
          </Typography><br/>
          <Divider /><br/>

          {/* ### 不正防止 */}
          <Typography variant="h6">不正防止</Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>目的</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            不正行為から当社の事業利益を保護するため。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>取得／処理されるデータ</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            IPアドレス、ブラウザ仕様、デバイス仕様、住所、メールアドレス、公的識別番号（該当する場合）。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>取得元</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            これらのデータはお客様から直接取得します。
          </Typography><br/>
          <Divider /><br/>

          {/* ### アンケート参加の一意性の確保 */}
          <Typography variant="h6">アンケート参加の一意性の確保</Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>目的</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            利用規約に従い、同一人物による複数回答を防止するため。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>取得／処理されるデータ</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            IPアドレス、ブラウザ仕様、デバイス仕様。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>取得元</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            これらのデータはお客様から直接取得します。
          </Typography><br/>
          <Divider /><br/>

          {/* ### 継続回答者の回答追跡（特別調査設計プロジェクト） */}
          <Typography variant="h6">継続回答者の回答追跡（特別調査設計プロジェクト）</Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>目的</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            特定の調査プロジェクトにおいて、時間の経過に伴う意見の変化を分析するため。該当する場合、永続的識別子はアンケート開始時に明示されます。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>取得／処理されるデータ</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            プロジェクト固有の永続的識別子。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>取得元</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            これらのデータはお客様から直接取得します。
          </Typography><br/>
          <Divider /><br/>

          {/* ### データ照合および強化 */}
          <Typography variant="h6">データ照合および強化</Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>目的</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            信頼できる第三者データパートナーとの照合により、お客様に関するデータを強化し、モニタープロフィールの精度向上およびアンケートの関連性向上を図るため。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>取得／処理されるデータ</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            永続的識別子、連絡先情報、メールアドレス、クッキー、モバイルデバイスID、ソーシャルログインデータ。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>取得元</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            これらのデータはお客様から直接取得するか、または他の二次データベースと組み合わせて取得します。
          </Typography><br/>
          <Divider /><br/>

          {/* ### 広告ターゲティングおよびメディア購買調査 */}
          <Typography variant="h6">広告ターゲティングおよびメディア購買調査</Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>目的</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            広告およびメディアキャンペーンの効果を理解し、より関連性の高い広告調査を提供するため。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>取得／処理されるデータ</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            IPアドレス、デバイス情報、クッキー、閲覧履歴、オンライン行動。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>取得元</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            これらのデータはお客様から直接取得するか、または他の二次データベースと組み合わせて取得します。
          </Typography><br/>
          <Divider /><br/>

          {/* ### モバイルおよびウェブサイト分析 */}
          <Typography variant="h6">モバイルおよびウェブサイト分析</Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>目的</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            訪問者が当社のウェブサイトおよびモバイルアプリケーションをどのように利用しているかを理解し、パフォーマンスおよび設計を改善するため。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>取得／処理されるデータ</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            IPアドレス、ブラウザ仕様、デバイス仕様、閲覧行動。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>取得元</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            これらのデータはお客様の利用状況から直接取得します。
          </Typography><br/>
          <Divider /><br/>

          {/* ### カスタマーサポート */}
          <Typography variant="h6">カスタマーサポート</Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>目的</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            モニターへの支援およびサポート提供のため。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>取得／処理されるデータ</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            氏名、連絡先情報、メールアドレス、お問い合わせ内容。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>取得元</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            これらのデータはお客様から直接取得します。
          </Typography><br/>
          <Divider /><br/>

          {/* データ保持 */}
          <Typography variant="h6">データ保持</Typography><br/>
          <Typography variant="body1" style={{ color: '#001627' }}>
            当社は、本プライバシーポリシーに記載された目的を達成するために必要な期間に限り、個人情報を保持します。ただし、法令によりより長期間の保持が求められる場合または許可される場合を除きます。
          </Typography><br/>
          <Divider /><br/>

          {/* データ削除 */}
          <Typography variant="h6">データ削除</Typography><br/>
          <Typography variant="body1" style={{ color: '#001627' }}>
            当社は、本プライバシーポリシーに記載された目的のために不要となった場合、個人情報を削除します。
          </Typography><br/>
          <Divider /><br/>

          {/* データセキュリティ */}
          <Typography variant="h6">データセキュリティ</Typography><br/>
          <Typography variant="body1" style={{ color: '#001627' }}>
            当社は、APPIの要件に従い、リスクに応じた適切なセキュリティレベルを確保するため、技術的および組織的な措置を実施します。
          </Typography><br/>
          <Divider /><br/>

          {/* 第三者(クライアントおよびサプライヤー) */}
          <Typography variant="h6">第三者(クライアントおよびサプライヤー)</Typography><br/>
          <Typography variant="body1" style={{ color: '#001627' }}>
            当社は、モニター管理および調査関連活動のために、第三者のベンダーおよび処理業者と個人情報を共有する場合があります。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>共有されるデータ</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            氏名、メールアドレス、住所、電話番号、クッキーID、モニターID、IPアドレス。
          </Typography><br/>
          <Divider /><br/>

          {/* 機密性、セキュリティおよび業界要件 */}
          <Typography variant="h6">機密性、セキュリティおよび業界要件</Typography><br/>
          <Typography variant="body1" style={{ color: '#001627' }}>
            当社は、日本に適用される業界基準に従い、適切な技術的および組織的措置を用いて個人情報を保護します。
          </Typography><br/>
          <Divider /><br/>

          {/* 越境データ移転 */}
          <Typography variant="h6">越境データ移転</Typography><br/>
          <Typography variant="body1" style={{ color: '#001627' }}>
            お客様の個人情報は、日本国内で移転および処理されます。
          </Typography><br/>
          <Typography variant="body1" style={{ color: '#001627' }}>
            そのような移転が行われる場合、当社はAPPIに従い適切な保護措置を確保し、受領者が十分なデータ保護水準を提供することを確認するか、必要に応じてお客様の同意を取得します。
          </Typography><br/>
          <Divider /><br/>

          {/* クッキーに関する開示 */}
          <Typography variant="h6">クッキーに関する開示</Typography><br/>
          <Typography variant="body1" style={{ color: '#001627' }}>
            クッキーは、ウェブサイトの機能提供、分析、不正防止、および調査測定を可能にするために、お客様のデバイスに保存される小さなテキストファイルです。
          </Typography><br/>
          <Divider /><br/>

          {/* 正確性 */}
          <Typography variant="h6">正確性</Typography><br/>
          <Typography variant="body1" style={{ color: '#001627' }}>
            当社は、個人情報が正確、完全かつ最新であるよう合理的な措置を講じます。変更があった場合はお客様が当社に通知する責任を負います。
          </Typography><br/>
          <Divider /><br/>

          {/* 児童のデータ */}
          <Typography variant="h6">児童のデータ</Typography><br/>
          <Typography variant="body1" style={{ color: '#001627' }}>
            当社は、日本の法令に基づき必要な場合を除き、適切な親または保護者の同意なしに未成年者の個人情報を意図的に取得することはありません。
          </Typography><br/>
          <Divider /><br/>

          {/* 機微情報 */}
          <Typography variant="h6">機微情報</Typography><br/>
          <Typography variant="body1" style={{ color: '#001627' }}>
            機微な個人情報は、法令で認められる場合に限り、明示的な同意または適切な保護措置のもとで取得されます。提供するかどうかはお客様が選択できます。
          </Typography><br/>
          <Divider /><br/>

          {/* 個人の権利 */}
          <Typography variant="h6">個人の権利</Typography><br/>
          <Typography variant="body1" style={{ color: '#001627' }}>
            APPIに基づき、お客様は以下の権利を有します：
          </Typography><br/>
          <ul style={{ color: '#001627' }}>
            <li>利用目的の通知の請求；</li>
            <li>個人情報へのアクセスの請求；</li>
            <li>訂正、追加、削除の請求；</li>
            <li>利用停止または削除の請求；</li>
            <li>第三者提供の停止の請求；</li>
          </ul>
          <Typography variant="body1" style={{ color: '#001627' }}>
            また、日本の個人情報保護委員会(PPC)に苦情を申し立てることもできます。
          </Typography><br/>
          <Divider /><br/>

          {/* データの保存および保持 */}
          <Typography variant="h6">データの保存および保持</Typography><br/>
          <Typography variant="body1" style={{ color: '#001627' }}>
            個人情報は、その適法かつ正当な利用目的に照らして適切な期間のみ保持されます。データエキシング デジタルは、お客様がモニター会員である限り個人情報を保持します。退会後は、法令により必要な期間のみ保持し、その後安全に削除されます。
          </Typography><br/>
          <Divider /><br/>

          {/* プライバシーポリシーの更新 */}
          <Typography variant="h6">プライバシーポリシーの更新</Typography><br/>
          <Typography variant="body1" style={{ color: '#001627' }}>
            本プライバシーポリシーは定期的に見直され、必要に応じて改定される場合があります。最新の内容は常にNipponPollsモニターサイト上で確認できます。継続的な参加は、更新内容への同意を意味します。
          </Typography><br/>
          <Divider /><br/>

          {/* お問い合わせ方法 */}
          <Typography variant="h6">お問い合わせ方法</Typography><br/>
          <Typography variant="body1" style={{ color: '#001627' }}>
            プライバシーまたはデータエキシング デジタルのプライバシー慣行に関するご質問やご懸念がある場合は、お問い合わせください。
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>データ保護責任者(DPO)氏名：</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            Varun Malhotra
          </Typography><br/>
          <Typography variant="subtitle1" style={{ color: '#455a64' }}>またはデータエキシング デジタルへの連絡先：</Typography>
          <Typography variant="body1" style={{ color: '#001627' }}>
            メール：<a href="mailto:info@dataxing.com" style={{ color: '#0000ff' }}>info@dataxing.com</a>
          </Typography><br/>

        </Paper>
      </Container>
    </div>
  );
}

export default PrivacyJp;
